import { EDITABLE_LIST_FIELD } from 'framework/list';
import { FormattedTextField } from 'framework/ui/field';
import { EMPTY_VALUE_INDICATOR } from 'framework/utils';
import { CreatedAtField, LinkField, NotesField } from './fields';
import { SEVERITY_OPTIONS, getOptionLabel } from '../constants';

export const getIncidentTableCells = ({
  createdAtSize,
  notesFieldSize,
}: {
  createdAtSize?: number;
  notesFieldSize?: number;
}) => [
  {
    type: EDITABLE_LIST_FIELD,
    source: 'shortDescription',
    isEditor: false,
    component: NotesField,
    gridCellProps: { size: 2.5 },
  },
  {
    type: EDITABLE_LIST_FIELD,
    source: 'linkToDetails',
    isEditor: false,
    component: LinkField,
    gridCellProps: { size: 2.5 },
  },
  {
    type: EDITABLE_LIST_FIELD,
    source: 'severity',
    isEditor: false,
    component: FormattedTextField,
    componentProps: {
      label: '',
      format: (value: string) => getOptionLabel(SEVERITY_OPTIONS, value) || EMPTY_VALUE_INDICATOR,
    },
    gridCellProps: { size: 1.5 },
  },
  {
    type: EDITABLE_LIST_FIELD,
    source: 'notes',
    isEditor: false,
    component: NotesField,
    gridCellProps: { size: notesFieldSize || 2.5 },
  },
  {
    type: EDITABLE_LIST_FIELD,
    source: 'createdAt',
    isEditor: false,
    component: CreatedAtField,
    gridCellProps: { size: createdAtSize || 2 },
  },
];
